import React from 'react';
import { styled } from 'linaria/react';

const CustomHeaderWrapper = styled('div')``;

export const CustomHeader = ({ children }) => {
  return <CustomHeaderWrapper>{children}</CustomHeaderWrapper>;
};
